const C = {
  name: "SolutionPlatformFinancialServices",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor" >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.5C12 3.46243 14.4624 1 17.5 1C20.5376 1 23 3.46243 23 6.5C23 9.53757 20.5376 12 17.5 12C16.2782 12 15.1495 11.6016 14.2366 10.9276L10.9276 14.2366C11.6016 15.1495 12 16.2782 12 17.5C12 20.5376 9.53757 23 6.5 23C3.46243 23 1 20.5376 1 17.5C1 14.4624 3.46243 12 6.5 12C7.59289 12 8.61132 12.3188 9.46741 12.8684L12.8684 9.46741C12.3188 8.61132 12 7.59289 12 6.5ZM17.5 3C15.567 3 14 4.567 14 6.5C14 8.433 15.567 10 17.5 10C19.433 10 21 8.433 21 6.5C21 4.567 19.433 3 17.5 3ZM6.5 14C4.567 14 3 15.567 3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14Z"/>
    </svg>
      `
};
export {
  C as SolutionPlatformFinancialServices
};
